import { useContext } from 'react'
import { AppContext } from '../context/AppContext'

const useApp = () => {
  const [state, setState] = useContext(AppContext)

  const _clickMarker = (prop) => {
    if (prop === 'one') {
      setState((state) => ({
        ...state,
        positions: {
          one: [0, 1.5, 0],
          two: [0, -0.52, 0],
          thre: [0, -0.53, 0]
        },
        scale: {
          one: 1,
          two: 0,
          thre: 0
        },
        visibility: {
          one: 'hidden',
          two: 'hidden',
          thre: 'hidden'
        }
      }))
    }
    if (prop === 'two') {
      setState((state) => ({
        ...state,
        positions: {
          one: [0, -0.49, 0],
          two: [0, 1.5, 0],
          thre: [0, -0.53, 0]
        },
        scale: {
          one: 0,
          two: 1,
          thre: 0
        },
        visibility: {
          one: 'hidden',
          two: 'hidden',
          thre: 'hidden'
        }
      }))
    }
    if (prop === 'thre') {
      setState((state) => ({
        ...state,
        positions: {
          one: [0, -0.49, 0],
          two: [0, -0.52, 0],
          thre: [0, 1.5, 0]
        },
        scale: {
          one: 0,
          two: 0,
          thre: 1
        },
        visibility: {
          one: 'hidden',
          two: 'hidden',
          thre: 'hidden'
        }
      }))
    }
  }

  const _clickOpen = (prop) => {
    setState((state) => ({
      ...state,
      open: true,
      shadows: 'false',
      number: prop
    }))
  }

  const _clickClose = (prop) => {
    setState((state) => ({
      ...state,
      positions: {
        one: [0, -0.49, 4],
        two: [2, -0.52, -4],
        thre: [-4, -0.53, -8]
      },
      scale: {
        one: 1,
        two: 1,
        thre: 1
      },
      visibility: {
        one: 'visible',
        two: 'visible',
        thre: 'visible'
      },
      open: false,
      shadows: 'accumulative',
      number: null,
      camera: [-2.0379520629086, -2.201758829609992, -0.38652322621527],
      rotation: [0, 0, 0]
    }))
  }


  const _clickMarkerAll = (prop) => {
    console.log(prop)
    if (prop === 'one-1') {
      setState((state) => ({
        ...state,
        camera: [-2.0379520629086, -2.201758829609992, -2.38652322621527],
      }))
    }

  }


  return {
    _clickMarker,
    _clickMarkerAll,
    _clickOpen,
    _clickClose,
    positions: state.positions,
    scale: state.scale,
    visibility: state.visibility,
    open: state.open,
    shadows: state.shadows,
    number: state.number,
    camera: state.camera,
    rotation: state.rotation
  }
}

export default useApp
